/**
 * Archive des entrees (« Archive » de 1Password, de Bitwarden depuis 2025) :
 * une entree qu'on n'utilise plus mais qu'on veut garder (ancien compte,
 * ancien employeur) sort de « Tous les elements », des favoris, des dossiers
 * et de la recherche, sans etre supprimee. Elle reste dans la vue Archives, a
 * la synchro, a l'export et a l'analyse de sante du coffre : son mot de passe
 * peut encore ouvrir un compte vivant, une reutilisation avec lui reste un
 * risque.
 *
 * Le drapeau vit DANS les secrets chiffres (`secrets.archived === true`),
 * comme `reprompt` : le serveur ne sait pas quelles entrees sont archivees, il
 * ne voit qu'une revision qui avance. Module pur, zero E/S.
 */
import type { EntrySecrets } from '@klavox/crypto-core';

/** Quelles entrees une liste montre : hors archives (defaut), archives seules, ou toutes. */
export type ArchiveFilter = 'exclude' | 'only' | 'include';

/** L'entree est-elle archivee ? Seul `true` archive (valeur importee mal formee = non). */
export function isArchived(secrets: EntrySecrets): boolean {
  return secrets['archived'] === true;
}

/** Secrets avec (ou sans) le drapeau d'archive ; rien d'autre ne change. Seul `true` est ecrit, l'absence vaut « actif ». */
export function withArchived(secrets: EntrySecrets, archived: boolean): EntrySecrets {
  const { archived: _archived, ...rest } = secrets;
  return archived ? { ...rest, archived: true } : rest;
}

/** L'entree passe-t-elle le filtre d'archive de la vue ? */
export function matchesArchiveFilter(secrets: EntrySecrets, filter: ArchiveFilter): boolean {
  if (filter === 'include') return true;
  return isArchived(secrets) === (filter === 'only');
}
